export var RangePatternType;
(function (RangePatternType) {
  RangePatternType["startRange"] = "startRange";
  RangePatternType["shared"] = "shared";
  RangePatternType["endRange"] = "endRange";
})(RangePatternType || (RangePatternType = {}));